module.exports = ".widget-content .table tr th {\r\n    background-color: #951623;\r\n    color: #fff;\r\n}\r\n\r\n.table-bordered {\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.nav-tabs[_ngcontent-c14] {\r\n    margin-bottom: 1em;\r\n}\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/dashboard/messages/message/message.component.css
// module id = ./src/app/modules/dashboard/messages/message/message.component.css
// module chunks = dashboard.module